export default __webpack_public_path__ + "static/image-28-b4cc3bdd085d4c2bfce1c3429ad871e0.jpg";